module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_250_500.a7bbea98.png";